import React from 'react'
import Img from 'gatsby-image'
import roomStyles from './room.module.sass'
import ButtonLink from './ButtonLink'

const TPBookingURL =
  'https://reservation.hotello.com/reservit/reserhotel.php?lang=EN&hotelid=440782'
const buttonText = `Book now`

export default props => {
  const {
    room,
    // orientation
  } = props
  // const { room_name, room_description, lowest_price, room_image } = props.room
  // const buttonContext = roomStyles.diningroom + "--buttonlink"

  return (
    <div className={roomStyles.room}>
      <Img
        className={roomStyles.image}
        fluid={room.room_image.localFile.childImageSharp.fluid}
      />
      <div className={roomStyles.info}>
        <h3 className={roomStyles.name}>{room.room_name}</h3>
        <p
          className={roomStyles.desc}
          dangerouslySetInnerHTML={{ __html: room.room_description }}
        />
        <p className={roomStyles.pricing}>
          <span className={roomStyles.currency}>$</span>
          <span className={roomStyles.lowprice}>{room.lowest_price}</span>
          &nbsp;-&nbsp;
          <span className={roomStyles.currency}>$</span>
          <span className={roomStyles.highprice}>{room.highest_price}</span>
          &nbsp;/ night
        </p>
        <ButtonLink
          url={TPBookingURL}
          text={buttonText}
          variant="default"
          addClass={roomStyles.buttonlink}
        />
      </div>
    </div>
  )
}
